import { MERCHANT_ENABLEMENTS } from "constants/action-types";

interface Action {
    type: string;
}

export const fetchMerchantEnablements = (): Action => ({
    type: MERCHANT_ENABLEMENTS.FETCH.START,
});
